"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var get_1 = __importDefault(require("lodash/get"));
var Table_1 = require("atomicComponents/atoms/Table/Table");
var theme_1 = require("common/theme");
var general_1 = require("utils/general");
var makeGetOffset = function (fontSize) { return function (defaultFontSize) { return (defaultFontSize - (fontSize !== null && fontSize !== void 0 ? fontSize : defaultFontSize)) / 2; }; };
var MainContainer = (0, styles_1.styled)('div', { shouldForwardProp: (0, general_1.omitProps)('color', 'fontSize') })(function (_a) {
    var _b;
    var theme = _a.theme, color = _a.color, fontSize = _a.fontSize;
    var getOffset = makeGetOffset(fontSize);
    var fontSizeOffset = getOffset(theme_1.DEFAULT_FONT_SIZE);
    var fontSizeOffsetSm = getOffset(Table_1.DEFAULT_FONT_SIZE_SM);
    // ToDo: check the formula in those paddings
    // if (fontSize) {
    //   console.log('fontSize', fontSize);
    //   console.log('DEFAULT_FONT_SIZE', DEFAULT_FONT_SIZE);
    //   console.log('DEFAULT_FONT_SIZE_SM', DEFAULT_FONT_SIZE_SM);
    //   console.log('fontSizeOffset', fontSizeOffset);
    //   console.log('fontSizeOffsetSm', fontSizeOffsetSm);
    // }
    return (_b = {
            height: theme.spacing(6.5),
            lineHeight: theme.spacing(2.5),
            color: color ? (0, get_1.default)(theme.palette, color) : undefined,
            fontSize: fontSize ? theme.spacing(fontSize) : undefined,
            padding: theme.spacing(4 + fontSizeOffset, 0, fontSizeOffset, 0),
            '.compact-row &': {
                height: theme.spacing(5.375),
                lineHeight: theme.spacing(2.5),
                padding: theme.spacing(2.75 + fontSizeOffsetSm, 0, 0.125 - fontSizeOffsetSm, 0), // compensating to leave the text aligned to the bottom
            },
            '.dense-row &': {
                height: theme.spacing(4),
                lineHeight: theme.spacing(2),
                padding: theme.spacing(1 + fontSizeOffsetSm, 0, 0.125 - fontSizeOffsetSm, 0), // compensating to leave the text aligned to the bottom
            },
            '.tight-row &': {
                height: theme.spacing(2.75),
                lineHeight: theme.spacing(2.5),
                padding: theme.spacing(0.5 + fontSizeOffset, 0, 0.125 - fontSizeOffset, 0), // compensating to leave the text aligned to the bottom
            }
        },
        _b[theme.breakpoints.down('sm')] = {
            paddingLeft: 0,
        },
        _b);
});
// if target stops working, change div for ClassNameExtendableHoC('div', 'SecondaryContainer'),
var SecondaryContainer = (0, styles_1.styled)('div', { shouldForwardProp: (0, general_1.omitProps)('color'), target: 'SecondaryContainer' })(function (_a) {
    var theme = _a.theme, color = _a.color;
    return ({
        height: theme.spacing(3.5),
        paddingBottom: theme.spacing(2),
        paddingLeft: 0,
        fontSize: theme.spacing(1.5),
        lineHeight: 1,
        color: (0, get_1.default)(theme.palette, color || 'neutral.contrastText'),
        '.compact-row &': {
            height: theme.spacing(2.625),
            paddingBottom: theme.spacing(1.125), // 9px
        },
        '.dense-row &': {
            height: theme.spacing(2),
            paddingBottom: theme.spacing(1),
        },
        '.tight-row &': {
            height: theme.spacing(1.25),
            paddingBottom: theme.spacing(1),
        },
    });
});
var DoubleCell = function (_a) {
    var main = _a.main, secondary = _a.secondary, mainProps = _a.mainProps, secondaryProps = _a.secondaryProps;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MainContainer, __assign({}, mainProps, { children: main })), (0, jsx_runtime_1.jsx)(SecondaryContainer, __assign({}, secondaryProps, { children: secondary }))] }));
};
exports.default = DoubleCell;
